
import {map} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { CategoryInterface } from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Rx';

import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
import { CreateCategoryComponent } from '../create-category/create-category.component';

@Component({
  selector: 'admin-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  categories$: Observable<CategoryInterface>;
  forms = new Map<any, FormGroup>();
  tableConfig = [
    {
      key: 'name',
      title: 'Category Name'
    },
    {
      key: 'icon',
      title: 'Icon'
    },
    {
      key: 'actions',
      title: 'Action'
    },
    {
      key: 'status',
      title: 'Status'
    }
  ];

  constructor(public store: Store<any>, public dialog: MatDialog) {
    this.categories$ = this.store.select(selectors.getAll('memoCategories')).pipe(map(items => {
      this.forms.clear();
      items.forEach(item =>
        this.forms.set(
          item,
          new FormGroup({
            name: new FormControl(item.name, Validators.required),
            icon: new FormControl(item.icon, Validators.required)
          })
        )
      );
      return items.sort(this.alphaSort);
    }));
  }

  ngOnInit() {
    this.store.dispatch(actions.MemoCategories.RequestAllAction);
  }

  itemActioned(event: any) {
    // lint
  }

  createCategory() {
    let dialogRef = this.dialog.open(CreateCategoryComponent, {
      height: '300px',
      width: '250px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(actions.MemoCategories.RequestCreateAction(result));
      }
    });
  }

  saveRow(row) {
    if (this.forms.get(row).valid) {
      this.store.dispatch(
        actions.MemoCategories.RequestSaveAction({ id: row.id, data: this.forms.get(row).value })
      );
    }
  }

  private alphaSort(a, b) {
    return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
  }
}
